var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement"},[(_vm.agree)?_c('img',{attrs:{"src":require("../assets/icon_multiple.png")}}):_c('img',{attrs:{"src":require("../assets/icon_multiple_disable.png")}}),_vm._t("agree")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dda9a5a8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreement.vue
// module id = null
// module chunks = 